import { Directive, Input, inject } from '@angular/core'
import { ElderSelectComponent, Sort } from '@elderbyte/ngx-starter'
import { VendorFilter, VendorService } from './vendor.service'

@Directive({
  selector: '[appVendorSelect]',
})
export class VendorSelectDirective {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private select = inject(ElderSelectComponent)
  private vendorService = inject(VendorService)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    this.select.displayProperty = 'name'
    this.select.placeholder = 'manufacturer.title'
    this.select.dataSource = this.vendorService
    this.select.sorts = [new Sort('name', 'asc')]
  }

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  @Input()
  public set selectableIds(ids: string[]) {
    if (ids) {
      this.select.filters = [VendorFilter.ids(ids)]
    }
  }
}
